var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","pa-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"ml-5 mt-5",attrs:{"sm12":""}},[_c('h2',[_vm._v(_vm._s(_vm.message))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }